var map = {
	"./abfrage.svg": 8172,
	"./add.svg": 6883,
	"./logo.png": 3153,
	"./logo.svg": 3935,
	"./logo2.jpeg": 8352,
	"./logo_langon.png": 1281,
	"./logo_langon.svg": 3673,
	"./minus.svg": 2410,
	"./tag.png": 6,
	"./trolley.svg": 1009,
	"./umlagern.svg": 6057
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;